export const DEFAULT_DATE_FORMAT = 'yyyy.MM.dd';
export const DEFAULT_DATE_MASK = '____.__.__';
export const DEFAULT_DATE_RANGE_MASK = '____.__.__ ~ ____.__.__';

// PopoverDateTimeRangePicker에서 사용하는 포맷 (시/분/초가 ":"로 구분)
export const POPOVER_DATETIME_FORMAT = 'yyyy.MM.dd HH:mm:ss';
export const POPOVER_DATETIME_FORMAT_NO_SECONDS = 'yyyy.MM.dd HH:mm';

// PopoverDateTimeRangePicker에서 사용하는 range mask (시/분/초가 ":"로 구분)
export const POPOVER_DATETIME_RANGE_MASK = '____.__.__ __:__:__ ~ ____.__.__ __:__:__';
export const POPOVER_DATETIME_RANGE_MASK_NO_SECONDS = '____.__.__ __:__ ~ ____.__.__ __:__';

// DatePickerInput min-width 동적 계산 상수 (mask 길이 × CHAR_WIDTH_PX + HORIZONTAL_PADDING_PX)
export const DATE_PICKER_INPUT_DEFAULT_MIN_WIDTH = 240;
export const DATE_PICKER_INPUT_CHAR_WIDTH_PX = 7.5;
export const DATE_PICKER_INPUT_HORIZONTAL_PADDING_PX = 56;

/**
 * 캘린더 prev/next 차단 경계 Date.
 * @description
 * - 최소: 0001.01.01 00:00:00.000 (date-fns가 0000을 invalid로 처리하는 라이브러리 최소 유효 년도)
 * - 최대: 9999.12.31 23:59:59.999 (4자리 yyyy 마스크의 최대값)
 * - new Date(year, ...)는 0~99년을 1900+y로 처리하는 JS quirk가 있어 setFullYear로 생성
 */
const createCalendarBoundaryDate = (
  year: number,
  month: number,
  day: number,
  hours: number,
  minutes: number,
  seconds: number,
  milliseconds: number,
): Date => {
  const date = new Date();
  date.setFullYear(year, month, day);
  date.setHours(hours, minutes, seconds, milliseconds);
  return date;
};

export const CALENDAR_MIN_DATE = createCalendarBoundaryDate(1, 0, 1, 0, 0, 0, 0);
export const CALENDAR_MAX_DATE = createCalendarBoundaryDate(9999, 11, 31, 23, 59, 59, 999);
